import { render, staticRenderFns } from "./CampaignInsights.vue?vue&type=template&id=45b7e3ed&scoped=true&"
import script from "./CampaignInsights.vue?vue&type=script&lang=js&"
export * from "./CampaignInsights.vue?vue&type=script&lang=js&"
import style0 from "./CampaignInsights.vue?vue&type=style&index=0&id=45b7e3ed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b7e3ed",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2332429520/src/pickl-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45b7e3ed')) {
      api.createRecord('45b7e3ed', component.options)
    } else {
      api.reload('45b7e3ed', component.options)
    }
    module.hot.accept("./CampaignInsights.vue?vue&type=template&id=45b7e3ed&scoped=true&", function () {
      api.rerender('45b7e3ed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Brand/CampaignInsights.vue"
export default component.exports